import { useEffect } from "react";
import { Box, Button, CloseButton, Dialog, HStack, Portal, Text, Textarea } from "@chakra-ui/react";

// Lead's TimelineKind enum only exposes one user-authorable value ("ManualEntry") --
// the rest (Created/Initialized/StatusChange/Note/Qualified/ConversionProposed/HandedToHuman)
// are written automatically by the system, so there's no kind-picker here unlike Candidate's.
const AddLeadTimelineEntryModal = ({ isOpen, onClose, description, setDescription, occurredAt, setOccurredAt, onSubmit, isLoading }) => {
    useEffect(() => {
        if (isOpen) setOccurredAt(new Date().toISOString().slice(0, 16));
    }, [isOpen, setOccurredAt]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner p={4}>
                    <Dialog.Content
                        bg="bg.card" color="white" borderColor="border.primary" border="1px solid"
                        w={{ base: "calc(100vw - 2rem)", md: "lg" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                        overflowY="auto" borderRadius={12}
                    >
                        <Dialog.Body pt={6} pb={6} px={6}>
                            <Text fontWeight={700} fontSize="lg" mb={4}>Dodaj wpis w osi czasu</Text>
                            <Text fontSize="sm" color="text.grey" mb={2}>Data zdarzenia</Text>
                            <Box mb={4}>
                                <input
                                    type="datetime-local"
                                    value={occurredAt}
                                    onChange={(e) => setOccurredAt(e.target.value)}
                                    style={{
                                        width: "100%", background: "var(--chakra-colors-bg-secondary, #1a1d23)",
                                        border: "1px solid var(--chakra-colors-border-primary, #2d3139)",
                                        borderRadius: "8px", color: "white", padding: "8px 12px", fontSize: "14px",
                                        colorScheme: "dark",
                                    }}
                                />
                            </Box>
                            <Text fontSize="sm" color="text.grey" mb={2}>Opis</Text>
                            <Textarea
                                placeholder="Co się wydarzyło..."
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                rows={4}
                                bg="bg.secondary" border="1px solid" borderColor="border.primary" color="white"
                                _placeholder={{ color: "text.grey" }} resize="vertical" mb={4}
                            />
                            <HStack justify="flex-end" gap={2}>
                                <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                                <Button variant="primary" size="sm" loading={isLoading} disabled={!description.trim()} onClick={onSubmit}>
                                    Dodaj
                                </Button>
                            </HStack>
                        </Dialog.Body>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" position="absolute" top="2" right="2" color="text.grey" />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default AddLeadTimelineEntryModal;
